<template>
    <footer class="footer has-cards">
        <div class="container">
            <div class="row row-grid align-items-center my-md">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2">Thank you for supporting us!</h3>
                    <h4 class="mb-0 font-weight-light">Let's get in touch on any of these platforms.</h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper">
                    <a target="_blank" rel="noopener"
                       v-on:click="tracker('Social', 'Clicked on social button', 'Yelp')"
                       href="http://yelp.com/biz/off-the-couch-santa-clara-2?utm_medium=badge_star_rating_reviews&amp;utm_source=biz_review_badge"
                       class="btn btn-neutral btn-icon-only btn-yelp btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-yelp"></i>
                    </a>
                    <a target="_blank" rel="noopener"
                       v-on:click="tracker('Social', 'Clicked on social button', 'Trip Advisor')"
                       href="https://www.tripadvisor.com/Attraction_Review-g32411-d25173542-Reviews-Off_The_Couch-Fremont_California.html"
                       class="btn btn-neutral btn-icon-only btn-trip btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-tripadvisor"></i>
                    </a>

                    <a target="_blank" rel="noopener" href="https://twitter.com/otc_games"
                       v-on:click="tracker('Social', 'Clicked on social button', 'Twitter')"
                       class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg" data-toggle="tooltip"
                        data-original-title="Follow us">
                            <i class="fa fa-twitter"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://www.facebook.com/offthecouchgames/"
                       v-on:click="tracker('Social', 'Clicked on social button', 'Facebook')"
                       class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip"
                        data-original-title="Like us">
                        <i class="fa fa-facebook-square"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://www.instagram.com/offthecouchgames/"
                       v-on:click="tracker('Social', 'Clicked on social button', 'Instagram')"
                       class="btn btn-neutral btn-icon-only btn-dribbble btn-lg btn-round" data-toggle="tooltip"
                        data-original-title="Follow us">
                        <i class="fa fa-instagram"></i>
                    </a>
                </div>
            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        Off The Couch, Inc &copy; {{year}} All Rights Reserved
                    </div>
                </div>
                <div class="col-md-6">
                <ul class="nav nav-footer justify-content-end">
                    <li class="nav-item">
                        <a href="/about" class="nav-link" target="_blank" rel="noopener">About Us</a>
                    </li>
                    <li class="nav-item">
                        <a href="/blog" class="nav-link" target="_blank" rel="noopener">Blog</a>
                    </li>
                </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
    export default {
        name: 'app-footer',
        data() {
            return {
                year: new Date().getFullYear()
            }
        },
        methods: {
            tracker(category, action, label) {
                this.$ga.event(category, action, label)
            }
        }
    };
</script>
<style scoped>
    .btn-yelp{
        background-color: #f43939;
        color: white;
        border: #f43939;
    }
    .btn-yelp:hover{
        background-color: #f43939;
        color: white;
        border: #f43939;
    }
    .btn-trip{
        background-color: #34e0a1;
        color: white;
        border: #34e0a1;
    }
    .btn-trip:hover{
        background-color: #34e0a1;
        color: white;
        border: #34e0a1;
    }
</style>
